import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";

/*BootstrapTable and table Related*/
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";

/*Loader */
import FadeIn from "react-fade-in";

/*animation*/
import Loader from "../../common/loader/Loader";
/*Styles*/
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import { writeAoaToFile } from "../../../utils/excelExport";
import { dateTimeReportFormatter2 } from "../../fomatters/DateFormatter";
import "./PlayerHistory.css";

const resultFormatter = (cell, row) => {
  // console.log(cell, row);
  let trans = row.transactionType == "X" ? "DELETED" : ""
  let result
  if (cell.toString()  == "255") {
    result = "PEND";
  } else if (cell.toString()  == "1") {
    result = "WIN";
  } else if (cell.toString()  == "0") {
    result = "LOSE";
  }else if (cell.toString()  == "3") {
    result = "NO BET";
  } else if (cell.toString() == "4") {
    result = "N/A";
  } else if (cell.toString()  == "6") {
    result = "N/A CANCEL";
  }else if (cell.toString()  == "5") {
    result = "N/A PITCHER";
  } else if (cell.toString() == "7") {
    result = "N/A SHORT";
  } else if (cell.toString()  == "2") {
    result = "PUSH";
  } else if (cell.toString()  == "10"){
    result = "LOSE BY 1/4"
  } else if(cell.toString() == "11" || cell == "9"){
    result = "WIN BY 1/4"
  } else {
    result = " "; // Opcional, para manejar otros casos no previstos
  }

  return ( 
    <div>
      <p className="text-center">{trans}</p>
      <p className="text-center">{result}</p>
    </div>
  )
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: 10,
    height: 10,
  },
  button: {
    display: "block",
  },
  formControl: {
    minWidth: 120,
  },
}));

const getMonday = (date) => {
  const d = new Date(date);
  const day = d.getDay();           
  const diff = day === 0 ? -6 : 1 - day;

  d.setDate(d.getDate() + diff);
  d.setHours(0, 0, 0, 0);         
  return d;
};

export default function PlayerHistory(props) {
  let curr = new Date();
  let week = [];

  for (let i = 1; i <= 7; i++) {
    let first = curr.getDate() - curr.getDay() + i;
    let day = new Date(curr.setDate(first)).toISOString().slice(0, 10);
    week.push(day);
  }


  function getWeekBoundsEastern(date = new Date()) {
    const easternDate = toEasternMidnight(date);

    const dayOfWeek = easternDate.getUTCDay();
    
    const idx = (dayOfWeek + 6) % 7;

   
    const monday = new Date(easternDate);
    monday.setUTCDate(easternDate.getUTCDate() - idx);

    const sunday = new Date(monday);
    sunday.setUTCDate(monday.getUTCDate() + 6);

    return { monday, sunday };
  }

  function toEasternMidnight(date) {
    const options = { timeZone: "America/New_York", year: "numeric", month: "2-digit", day: "2-digit" };
    const parts = new Intl.DateTimeFormat("en-CA", options).formatToParts(date);
    const y = parts.find(p => p.type === "year").value;
    const m = parts.find(p => p.type === "month").value;
    const d = parts.find(p => p.type === "day").value;

    return new Date(`${y}-${m}-${d}T00:00:00-05:00`); 
  }

 
  function formatYYYYMMDD(date) {
    const y = date.getUTCFullYear();
    const m = String(date.getUTCMonth() + 1).padStart(2, "0");
    const d = String(date.getUTCDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }
  const { monday, sunday } = getWeekBoundsEastern(new Date());

  const classes = useStyles();
  const [playerHistory, setPlayerHistory] = useState([]);
  const [playerWeeklyHistory, setPlayerWeeklyHistory] = useState([]);
  const [weekDate, setWeekDate] = useState(getMonday(new Date()));
  const [totalsPlayer,setTotalsPlayer] = useState({Win: 0, Loss: 0, NumWagers: 0})

  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [isLoading, setIsLoading] = useState(true);

  // const [startDate, setStartDate] = useState(week[0]);
  // const [endDate, setEndDate] = useState(week[6]);
  const [startDate, setStartDate] = useState(formatYYYYMMDD(monday));
  const [endDate, setEndDate] = useState(formatYYYYMMDD(sunday));
  let idPlayer = props.Player.idPlayer;

  const [filter, setFilter] = useState("");
  const onFilterChange = useCallback(
    (event) => setFilter(event.target.value),
    []
  );

  useEffect(() => {
    HistoryValues();
  }, []);

  useEffect(() => {
    WeeklyValues();
  }, [weekDate]);

  const handleShow = () => {
    HistoryValues();
  };

  const HistoryValues = () => {
    let idPlayer = props.Player.idPlayer;
    axios({
      method: "post",
      url:
        process.env.REACT_APP_API2_URL +
        "/Player/GetPlayerHistoryWagers?idPlayer=" +
        idPlayer +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate +
        "&filter=" +
        filter,
    }).then((response) => {
      // const data = response.data.map((item) => ({
      //   ...item,
      //   RiskWin:
      //     item.RiskAmount && item.WinAmount
      //       ? `${item.RiskAmount}/${item.WinAmount}`
      //       : "",
      //   UserPhone: `${item.LoginName}/${item.PhoneLine}`,
      //   Amount: !isNaN(parseFloat(item.Amount)) ? Math.round(parseFloat(item.Amount)) : item.Amount,
      //   Balance: !isNaN(parseFloat(item.Balance)) ? Math.round(parseFloat(item.Balance)) : item.Balance,
      // }));

      // const data = response.data
      // .map((item) => ({
      //   ...item,
      //   RiskWin:
      //     item.RiskAmount && item.WinAmount
      //       ? `${item.RiskAmount}/${item.WinAmount}`
      //       : "",
      //   UserPhone: `${item.LoginName}/${item.PhoneLine}`,
      //   Amount: !isNaN(parseFloat(item.Amount)) ? Math.round(parseFloat(item.Amount)) : item.Amount,
      //   Balance: !isNaN(parseFloat(item.Balance)) ? Math.round(parseFloat(item.Balance)) : item.Balance,
      // }))
      // .sort((a, b) => {
      
      //   if (a.DetailDescription === "BALANCE FORWARD" && b.DetailDescription !== "BALANCE FORWARD") {
      //     return -1;
      //   }
      //   if (b.DetailDescription === "BALANCE FORWARD" && a.DetailDescription !== "BALANCE FORWARD") {
      //     return 1;
      //   }

      //   return 0
      // });

       const base = response.data.map((item) => ({
          ...item,
          riskWin:
            item.riskAmount && item.winAmount
              ? `${item.riskAmount}/${item.winAmount}`
              : "",
          userPhone: `${item.loginName}/${item.phoneLine}`,
          amount: !isNaN(parseFloat(item.amount)) ? Math.round(parseFloat(item.amount)) : item.amount,
          balance: !isNaN(parseFloat(item.balance)) ? Math.round(parseFloat(item.balance)) : item.balance,
        }));

        const RECENT_FIRST = false;

        const groupDateByTicket = base.reduce((acc, it) => {
          const t = String(it.ticketNumber ?? "");
          const d = new Date(it.settledDate || 0).getTime();
          const val = Number.isFinite(d) ? d : Number.POSITIVE_INFINITY;
          acc[t] = Math.min(acc[t] ?? Number.POSITIVE_INFINITY, val);
          return acc;
        }, {});  

        const data = base.sort((a, b) => {
          // "BALANCE FORWARD" primero
          const aBF = a.detailDescription === "BALANCE FORWARD";
          const bBF = b.detailDescription === "BALANCE FORWARD";
          if (aBF !== bBF) return aBF ? -1 : 1;

          const ga = groupDateByTicket[String(a.ticketNumber ?? "")] ?? Number.POSITIVE_INFINITY;
          const gb = groupDateByTicket[String(b.ticketNumber ?? "")] ?? Number.POSITIVE_INFINITY;
          if (ga !== gb) return RECENT_FIRST ? gb - ga : ga - gb;

          const ta = Number(a.ticketNumber) || 0;
          const tb = Number(b.ticketNumber) || 0;
          if (ta !== tb) return ta - tb;

          const wa = Number(a.idWager) || 0;
          const wb = Number(b.idWager) || 0;
          if (wa !== wb) return wa - wb;

          const da = new Date(a.settledDate || 0).getTime();
          const db = new Date(b.settledDate || 0).getTime();
          return da - db;
        });

      

      // setPlayerHistory(data);
      
      let lastIdWager;                 // undefined
      const openBetList = [];

      data.map(function(keyMain) {
        // 1) Aseguramos que 'id' sea un número
        const id = Number(keyMain.idWager);

        // 2) Si es -99 (siempre nuevo) o distinto del último, creamos un nuevo grupo
        if (id === -99 || id !== lastIdWager) {
          console.log("Adding NEW wager ===> ", id);
          keyMain.leg = [];
          openBetList.push(keyMain);
          lastIdWager = id;

        // 3) Si es el mismo id que el anterior, lo agregamos al 'Leg' del último elemento
        } else {
          console.log("Adding to existing wager ===> ", id);
          const tempGame = openBetList[openBetList.length - 1];
          tempGame.leg.push(keyMain);
          openBetList[openBetList.length - 1] = tempGame;
        }
});
      
      const { win, loss, totalwagers } = openBetList.reduce(
        (acc, item) => {
          const amount = parseFloat(item.amount);
          if (!isNaN(amount)) {
            if (amount > 0) {
              acc.win += amount;
            } else {
              acc.loss += amount;
            }
          }
          if (item.idWager !== "-1" && item.idWager !== " ") {
            acc.totalwagers++;
          }
          return acc;
        },
        { win: 0, loss: 0, totalwagers: 0 }
      );
      openBetList[0].riskWin = `${win}/${Math.abs(loss)}`; 
      setPlayerHistory(openBetList);
      console.log(openBetList);
      setTotalsPlayer({ Win: win, Loss: loss, NumWagers: totalwagers });
      setIsLoading(false);
    });
  };

  async function exportBetReport(data) {
    const worksheetData = [];

    worksheetData.push([`Bet Report (${startDate} - ${endDate})`]); // Título
    worksheetData.push([]);

    worksheetData.push([
      "Ticket #",
      "Placed Date",
      "Sport",
      "Description",
      "Teams",
      "Result",
      "Risk/Win",
      "Amount",
      "IP",
    ]);

    data.forEach((bet) => {
      let trans = bet.transactionType === "X" ? "DELETED" : "";
      let formattedResult = "";
      switch (parseInt(bet.result)) {
        case 255:
          formattedResult = "PEND";
          break;
        case 1:
          formattedResult = "WIN";
          break;
        case 0:
          formattedResult = "LOSE";
          break;
        case 3:
          formattedResult = "NO BET";
          break;
        case 6:
          formattedResult = "N/A CANCEL";
          break;
        case 2:
          formattedResult = "PUSH";
          break;
        case 10:
          formattedResult = "LOSE BY 1/4";
          break;
        case 11:
        case 9:
          formattedResult = "WIN BY 1/4";
          break;
        default:
          formattedResult = "";
      }

      worksheetData.push([
        bet.ticketNumber.toString(),
        bet.placedDate.split("T").join(" "),
        bet.idSport,
        bet.completeDescription,
        "",
        trans,
        bet.riskWin,
        bet.amount,
        bet.ip,
      ]);

      worksheetData.push([
        "",
        "",
        "",
        bet.detailDescription,
        bet.gameInfo?.visitorNumber ? "[" + bet.gameInfo?.visitorNumber + "]" + bet.gameInfo?.visitorTeam + " ("+bet.gameInfo?.visitorScore+")" +" - " +" ["+ bet.gameInfo?.homeNumber + "]" + bet.gameInfo?.homeTeam + " (" + bet.gameInfo?.homeScore+")" : "",
        formattedResult,
        "",
        "",
        "",
      ]);

      if (bet.leg && bet.leg.length > 0) {
        bet.leg.forEach((leg) => {
          worksheetData.push([
            "",
            "",
            "",
            leg.detailDescriptionLang,
            bet.gameInfo?.visitorNumber ? "[" + leg.gameInfo?.visitorNumber + "]" + leg.gameInfo?.visitorTeam + " ("+leg.gameInfo?.visitorScore+")" +" - " +" ["+ leg.gameInfo?.homeNumber + "]" + leg.gameInfo?.homeTeam + " (" + leg.gameInfo?.homeScore+")" : "",
            "",
            "",
            "",
            "",
          ]);
        });
      }

      worksheetData.push([]);
    });

    await writeAoaToFile(
      worksheetData,
      "Bet Report",
      `bet_report_${startDate}_to_${endDate}.xlsx`,
      {
        columnWidths: [
          { wch: 10 },
          { wch: 25 },
          { wch: 10 },
          { wch: 70 },
          { wch: 10 },
          { wch: 10 },
          { wch: 10 },
          { wch: 15 },
        ],
        merges: [{ s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }],
      }
    );
  }

  const WeeklyValues = () => {
    let idPlayer = props.Player.idPlayer;
    const startDate = formatDateForApi(weekDate);
    axios({
      method: "get",
      url:
        process.env.REACT_APP_API2_URL +
        "/Player/GetPlayerWeeklyStatistics?playerId=" +
        idPlayer +
        "&startDate=" +
        startDate ,
    }).then((response) => {
      setPlayerWeeklyHistory(response.data);
      setIsLoading(false);
    });
  };

  const formatDateForApi = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  };

  const handleChangeStartDate = (event) => {
    setStartDate(event.target.value);
  };

  const handleChangeEndDate = (event) => {
    setEndDate(event.target.value);
  };

  const handleWeekChange = (e) => {
    // const date = new Date(e.target.value); // Convierte el valor del campo a una fecha
    const [year, month, day] = e.target.value.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    const monday = getMonday(date); // Calcula el lunes de esa semana
    console.log("getMonday last monday===>", monday);
    setWeekDate(monday); // Actualiza el estado con el lunes calculado
  };

  const handleLastWeek = () => {
    const lastWeekDate = new Date(weekDate);
    lastWeekDate.setDate(weekDate.getDate() - 7);
    const monday = getMonday(lastWeekDate);
    console.log("getMonday last monday2===>", monday);
    setWeekDate(monday);
  };

  const isExpandableRow = (row) => {
    return true;
  };

  class BSTable extends React.Component {
    render() {
      if (this.props.data) {
        return (
          <Table className="table-open-bets">
            <TableRow>
              <TableCell>
                <p>
                  <b> {this.props.data.detailDescription}</b>
                  <br />
                  {this.props.data.idSport !== ""
                    ? this.props.data.idWager
                    : ""}
                  <br />
                  <small>
                    <b>Placed Date: {this.props.data.placedDate} </b>
                  </small>
                </p>
              </TableCell>
              <TableCell>
                <p>
                  <b> {this.props.data.loginName} </b>
                  <br />
                  {this.props.data.ip ? this.props.data.ip : ""}
                  <br />
                </p>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan="2">
                <p>
                  <b>Ticket Description</b>
                </p>
                <li key={this.props.data.idWager}>
                  {this.props.data.detailDescription}{" "}
                  <div className="flex flex-col gap-2 pl-[30px] pb-[10px]">
                    <div className="flex gap-2">
                     <div className="flex flex-col ">
                        <span>[{this.props.data.gameInfo?.visitorNumber}]{this.props.data.gameInfo?.visitorTeam}  </span>
                        <span className="text-xs font-semibold">SCORE: {this.props.data.gameInfo?.visitorScore}</span>
                      </div>
                      {/* <div>
                        <span>{this.props.data.gameInfo?.winnerTeam === 1 ? "WIN" : ""}</span>
                      </div> */}
                    </div>
                    <div className="flex gap-2">
                      <div className="flex flex-col ">
                        <span>[{this.props.data.gameInfo?.homeNumber}]{this.props.data.gameInfo?.homeTeam}  </span>
                        <span className="text-xs font-semibold">SCORE: {this.props.data.gameInfo?.homeScore}</span>
                      </div>
                      {/* <div>
                        <span>{this.props.data.gameInfo?.winnerTeam === 2 ? "WIN" : ""}</span>
                      </div> */}
                    </div>
                  </div>
                </li>

                {this.props.data.leg &&
                  this.props.data.leg.map(function (item, i) {
                    return <li key={i}>{item.detailDescription}
                      <div className="flex flex-col gap-2 pl-[30px] pb-[10px]">
                        <div className="flex gap-2">
                        <div className="flex flex-col ">
                            <span>[{item.gameInfo?.visitorNumber}]{item.gameInfo?.visitorTeam}  </span>
                            <span className="text-xs font-semibold">SCORE: {item.gameInfo?.visitorScore}</span>
                          </div>
                          <div>
                            <span>{item.gameInfo?.winnerTeam === 1 ? "WIN" : ""}</span>
                          </div>
                        </div>
                        <div className="flex gap-2">
                          <div className="flex flex-col ">
                            <span>[{item.gameInfo?.homeNumber}]{item.gameInfo?.homeTeam}  </span>
                            <span className="text-xs font-semibold">SCORE: {item.gameInfo?.homeScore}</span>
                          </div>
                          {/* <div>
                            <span>{item.gameInfo?.winnerTeam === 2 ? "WIN" : ""}</span>
                          </div> */}
                        </div>
                      </div>
                    </li>;
                  })}
                <br />
                <p style={{ textAlign: "center" }}>
                  <b>Risk/Win : </b>
                  {this.props.data.riskAmount}/ {this.props.data.winAmount}{" "}
                </p>
              </TableCell>
            </TableRow>
          </Table>
        );
      } else {
        return <p>?</p>;
      }
    }
  }

  const expandComponent = (row) => {
    return <BSTable data={row} />;
  };

  // Función para formatear la fecha
  const formatDate = (dateString) => {
    const options = { month: "short", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  /*Loader*/
  const getTotalValues = (key) => {
    const totalValue = playerWeeklyHistory.reduce((acc, item) => {
      if (item.date !== "0001-01-01T00:00:00") {
        acc += item[key];
      }
      return acc;
    }, 0);
    return totalValue;
  };

  const options = {
    beforeShowError: (type, msg) => {
      this.setState({ errType: type, errMsg: msg });
    },
  };

  // const typeDescriptionFormatter = (cell, row) => {
  //   return (
  //     <>
  //       <div>{row.CompleteDescription}</div>
  //       <div className="nospace">{row.DetailDescription}</div>
  //     </>
  //   );
  // };

  const typeDescriptionFormatter = (cell, row) => {
  return (
    <>

      <div>{row.completeDescription}</div>

      <div className="nospace">{row.detailDescription}</div>

      {Array.isArray(row.leg) &&
        row.leg.map((leg, idx) => (
          <div key={leg.idWagerDetail || idx} className="nospace">
            {leg.detailDescription}
          </div>
        ))}
    </>
  );
};

const mapResultCode = (code) => {
  if (code === undefined || code === null) return " ";

  const cell = code.toString();

  if (cell === "255") return "PEND";
  if (cell === "1")   return "WIN";
  if (cell === "0")   return "LOSE";
  if (cell === "3")   return "NO BET";
  if (cell === "4")   return "N/A";
  if (cell === "6")   return "N/A CANCEL";
  if (cell === "5") return "N/A PITCHER";
  if (cell === "7") return "N/A SHORT";
  if (cell === "2")   return "PUSH";
  if (cell === "10")  return "LOSE BY 1/4";
  if (cell === "11" || cell === "9") return "WIN BY 1/4";

  return " ";
};

const resultFormatter = (cell, row) => {
  const mainResult  = row.transactionType == "X" ? "DELETED" : mapResultCode(row.result);               // row.result
  const firstDetail = mapResultCode(row.detailResult);   // detalle principal

  const legResults =
    Array.isArray(row.leg) ? row.leg.map(l => mapResultCode(l.detailResult)) : [];

  return (
    <>
      <div>{mainResult}</div>

      <div>{firstDetail}</div>

      {legResults.map((r, idx) => (
        <div key={idx}>{r}</div>
      ))}
    </>
  );
};

const userIpFormatter = (cell, row) => {
  return (
    <div>
      <div>{row.loginName}</div>
      <div>{row.ip}</div>
    </div>
  );
};



  return (
    <React.Fragment>
      {isLoading ? (
        <FadeIn>
          <div className="d-flex justify-content-center align-items-center">
            <Loader height={360} width={360} />
          </div>
        </FadeIn>
      ) : (
        ""
      )}
      <div className="flex flex-col gap-4">
        <form
          className={`flex flex-row items-center justify-center w-full`}
          noValidate
        >
          <div className="flex flex-col w-full gap-4 web-options">
            <div className="flex gap-4">
              <TextField
                variant="outlined"
                id="startDate"
                label="Start Date"
                type="date"
                size="small"
                defaultValue={startDate}
                onChange={handleChangeStartDate}
              />
              <TextField
                variant="outlined"
                id="endDate"
                label="End Date"
                type="date"
                size="small"
                defaultValue={endDate}
                onChange={handleChangeEndDate}
              />
            </div>
            <RadioGroup label value={filter} onChange={onFilterChange} row>
              <FormControlLabel
                control={<Radio value="all" size="small" color="primary" />}
                label="All"
                labelPlacement="end"
              />
              <FormControlLabel
                control={<Radio value="wagers" size="small" color="primary" />}
                label="Wagers"
                labelPlacement="end"
              />
              <FormControlLabel
                control={
                  <Radio value="payments" size="small" color="primary" />
                }
                label="Payments"
                labelPlacement="end"
              />
              <FormControlLabel
                control={
                  <Radio value="freeplays" size="small" color="primary" />
                }
                label="Free Plays"
                labelPlacement="end"
              />
              <FormControlLabel
                control={
                  <Radio value="adjustments" size="small" color="primary" />
                }
                label="Adjustments"
                labelPlacement="end"
              />
              <FormControlLabel
                control={<Radio value="casino" size="small" color="primary" />}
                label="Casino"
                labelPlacement="end"
              />
              <FormControlLabel
                control={<Radio value="horses" size="small" color="primary" />}
                label="Horses"
                labelPlacement="end"
              />
              <FormControlLabel
                control={<Radio value="rbl" size="small" color="primary" />}
                label="RBL"
                labelPlacement="end"
              />
            </RadioGroup>
            <Button variant="contained" color="primary" onClick={handleShow}>
              Show
            </Button>
          </div>
        </form>
        <Button
          type="button"
          color="primary"
          variant="contained"
          onClick={() => exportBetReport(playerHistory)}
        >
          Export XLSX
        </Button>

        <div className="table-responsive table-hist">
          <BootstrapTable
            className=" react-bs-table table-hist"
            data={playerHistory}
            expandableRow={isExpandableRow}
            expandComponent={expandComponent}
            options={options}
          >
            <TableHeaderColumn
              isKey={true}
              dataField="ticketNumber"
              width="100"
            >
              #
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="settledDate"
              dataFormat={dateTimeReportFormatter2}
              width="120"
            >
              Date
            </TableHeaderColumn>
            <TableHeaderColumn dataField="idSport" width="60">
              Sport
            </TableHeaderColumn>
            {/* <TableHeaderColumn dataField="completeDescription">
              Type
            </TableHeaderColumn>
            <TableHeaderColumn dataField="detailDescription" width="300">
              Description
            </TableHeaderColumn> */}
            <TableHeaderColumn
              dataField="typeDescription"
              dataFormat={typeDescriptionFormatter}
              width="400"
              columnClassName="custom-padding nospace"
            >
              Type/Description
            </TableHeaderColumn>

            <TableHeaderColumn
              flex="1"
              dataField="result"
              dataFormat={resultFormatter}
              width="90"
            ></TableHeaderColumn>
            <TableHeaderColumn dataField="riskWin" width="100">
              Risk/Win
            </TableHeaderColumn>
            <TableHeaderColumn dataField="amount" width="100">
              Amount
            </TableHeaderColumn>
            <TableHeaderColumn dataField="balance" width="100">
              Balance
            </TableHeaderColumn>
            <TableHeaderColumn dataField="ip" dataFormat={userIpFormatter} width="250">
              User/IP
            </TableHeaderColumn>
          </BootstrapTable>
        </div>
        <div className="w-full web-options">
          <div>
            Loaded: {playerHistory?.[0]?.totalTransactions ?? 0} transaction(s)
            and {totalsPlayer.NumWagers ?? 0} wager(s)
          </div>
          <div>
            Won {totalsPlayer.Win ?? 0}, Lost{" "}
            {totalsPlayer.Loss ?? 0}
          </div>
        </div>

        <h1 className="font-black">Weekly Statistics</h1>
        <div className="w-full web-options">
          <TextField
            variant="outlined"
            id="weekDate"
            label="Week"
            type="date"
            size="small"
            value={weekDate.toISOString().split("T")[0]}
            onChange={handleWeekChange}
            className="mb-2"
          />
          <Button
            variant="contained"
            color="primary"
            onClick={WeeklyValues}
            className="mb-2"
          >
            Refresh
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleLastWeek}
            className="mb-2"
          >
            Last Week
          </Button>
        </div>
        <div className="table-responsive react-bs-table">
          <table className="w-full text-xs">
            <thead>
              <tr>
                <th>Date</th>
                <th>BOW</th>
                {playerWeeklyHistory.slice(1, 8).map((item, index) => (
                  <th key={index}>{formatDate(item.date)}</th>
                ))}
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Won/Lost</td>
                <td></td>
                {playerWeeklyHistory.slice(1, 8).map((item, index) => (
                  <td key={index}>{parseInt(item.wonLost)}</td>
                ))}
                <td>{parseInt(getTotalValues("wonLost"))}</td>
              </tr>
              <tr>
                <td>Cash In/Out</td>
                <td></td>
                {playerWeeklyHistory.slice(1, 8).map((item, index) => (
                  <td key={index}>{parseInt(item.cashInOut)}</td>
                ))}
                <td>{parseInt(getTotalValues("cashInOut"))}</td>
              </tr>
              <tr>
                <td>Balance</td>
                <td>{playerWeeklyHistory[0]?.balance}</td>
                {playerWeeklyHistory.slice(1, 8).map((item, index) => (
                  <td key={index}>{parseInt(item.balance)}</td>
                ))}
                <td>{parseInt(playerWeeklyHistory[8]?.balance)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </React.Fragment>
  );
}
